/*
 * Top level module for Substitutions page
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/substitutions/substitutionsView",
  "modules/substitutions/substitutionList/substitutionListModule",
  "modules/substitutions/substitutionSearch/substitutionSearchModule",
  "modules/substitutions/substitutionGroup/substitutionGroupModule",
  "modules/substitutions/substitutionModel",
], function (
  Marionette,
  Backbone,
  $,
  Properties,
  Messenger,
  SubstitutionsView,
  SubstitutionListModule,
  SubstitutionSearchModule,
  SubstitutionGroupModule,
) {
  "use strict";

  const SubstitutionsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "substitutions";
      this.region = options.region;
      this._setUpVents();
      this.substitutionGroups = null;
      this.newGroup = null; //variable for storing a new group in while it is being created
      this.router = new Router({
        controller: this,
      });
    },
    show: function () {
      const kbId = Messenger.reqres.request("active:kb");
      if (!Messenger.reqres.request("can:view:substitutionsTab")) {
        throw new Error("Not allowed to view or edit Substitutions");
      }
      Backbone.history.navigate(kbId + "/substitutions");
      document.title = $.t("menuBar.substitutions") + " - " + Properties.applicationName;
      this.layout = new SubstitutionsView.substitutionsLayout();
      this.substitutionList = this.addSubModule(
        new SubstitutionListModule({ region: this.layout.substitutionList }),
      );
      this.substitutionSearch = this.addSubModule(
        new SubstitutionSearchModule({ region: this.layout.substitutionSearch }),
      );
      this.substitutionGroup = this.addSubModule(
        new SubstitutionGroupModule({ region: this.layout.substitutionGroup }),
      );
      this.layout.on(
        "add:group",
        function () {
          this.addGroup();
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    addGroup: function () {
      if (this.newGroup === null || !this.newGroup.isNew()) {
        this._addGroup();
      } else {
        //we should try saving existing new group, and if successful, create a new group
        Messenger.save(function (success) {
          if (success) {
            this._addGroup();
          }
        }, this);
      }
    },
    _addGroup: function () {
      this.newGroup = this.substitutionGroups.addNewGroup();
      this.substitutionList.selectItem(this.newGroup); //select the new group in the list
    },
    _showSubViews: function () {
      this.substitutionGroups = Messenger.reqres.request("substitutions");
      this.substitutionList.show(this.substitutionGroups);
      this.substitutionSearch.show();
      //this.substitutionGroup.showGroup();
    },
    _route: function (kbId) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      if (!isAuthor) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "substitutions");
      this.show();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:substitutions",
        function () {
          //        if (!this.isOpen){
          //          this.show();
          //        }
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "click:search",
        function (data) {
          if (!data.searchEntries) {
            //filter current substitutions
            const searchResults = this.substitutionGroups.search(data.searchField);
            this.substitutionList.show(searchResults);
            this.substitutionSearch.setNoResults(searchResults.length === 0);
          } else {
            //get filtered substitutions by entry
            const filteredSubs = Messenger.reqres.request(
              "filtered:substitutions",
              data.searchField,
            );
            this.substitutionList.show(filteredSubs);
            filteredSubs.onSynced(function () {
              this.substitutionSearch.setNoResults(filteredSubs.length === 0);
            }, this);
          }
        },
        this,
      );

      Messenger.vent.on(
        "clear:search",
        function () {
          this.substitutionList.show(this.substitutionGroups); //reconnect full sub group list to collection
        },
        this,
      );

      Messenger.vent.on(
        "delete:group",
        function (model) {
          if (this.newGroup !== null && this.newGroup === model) {
            //deleting pending model
            this.newGroup = null;
          }
          model.deleteModel(); //deleting the model triggers the selectable list to no longer consider this model selected
        },
        this,
      );
    },
  });

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/substitutions": "_route",
    },
  });

  return SubstitutionsController;
});
